import { render, staticRenderFns } from "./CsRevisionFirmas.vue?vue&type=template&id=9988dd70"
import script from "./CsRevisionFirmas.vue?vue&type=script&lang=js"
export * from "./CsRevisionFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports